import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Cancel from "../assets/img/Cancel.svg";
import LeftImg from "../assets/img/Left.svg";
import WriteImg from "../assets/img/Write.svg";

const Navigation = (props) => {
  const navigate = useNavigate();
  /**모바일 기종 분기처리 (ios, 안드로이드, 그 외) */
  var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
  
  const backHandler = () => {
    console.log(varUA);
    if (varUA.indexOf("android") > -1) {
      //안드로이드
      window?.postMessageToAndroid?.movusCallBack("back");
      return "android";
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
      ) {
        //IOS
        window?.webkit?.messageHandlers?.movusCallBack?.postMessage({
          command: "back",
        });
      return "ios";
    } else {
      window?.postMessageToAndroid?.movusCallBack("back");
      navigate(-1);
      return "other";
    }
  };
  

  return (
    <div className="header_wrap">
      <div className="headers">
        {props.headerUi.goback && props.headerUi.goback !== undefined ? (
          <button className="goback_ico" onClick={backHandler}>
            <img src={LeftImg} alt="뒤로가기" />
          </button>
        ) : null}
        <h1 className="font-header">{props.pageName}</h1>
        {props.headerUi.closeAll && props.headerUi.closeAll !== undefined ? (
          <button className="close_ico" onClick={backHandler}>
            <img src={Cancel} alt="닫기" />
          </button>
        ) : null}
        {props.headerUi.Navi !== null && props.headerUi.Navi !== undefined ? (
          <Link className="write_ico" to={props.headerUi.Navi}>
            <img src={WriteImg} alt="닫기" />
          </Link>
        ) : null}
      </div>
    </div>
  );
};
export default Navigation;
